import type { ApiInitialArgs } from '../api/types';

const PREFERRED_AUTH_RESTART_MODE_KEY = 'runai:preferred-auth-restart-mode';

export function storePreferredAuthRestartMode(mode: NonNullable<ApiInitialArgs['initialAuthMethod']>) {
  try {
    window.sessionStorage.setItem(PREFERRED_AUTH_RESTART_MODE_KEY, mode);
  } catch {
    // ignore storage failures
  }
}

export function peekPreferredAuthRestartMode(): ApiInitialArgs['initialAuthMethod'] | undefined {
  try {
    const mode = window.sessionStorage.getItem(PREFERRED_AUTH_RESTART_MODE_KEY);
    if (mode !== 'phoneNumber' && mode !== 'qrCode') {
      return undefined;
    }
    return mode;
  } catch {
    return undefined;
  }
}

export function clearPreferredAuthRestartMode() {
  try {
    window.sessionStorage.removeItem(PREFERRED_AUTH_RESTART_MODE_KEY);
  } catch {
    // ignore storage failures
  }
}
